<template>
  <div class="main_center inspectionResultEntry">
    <div class="content">
        <searchBox
                :dialogVisible.sync="moreSearchItem"
                @dialogCancle="dialogCancle"
                title="更多筛选">
            <div class="search-drawer">
                <el-form :model="form" label-position="top" ref="form">
                        <el-form-item label="抽取编号：">
                            <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" v-model="form.extractCode"></el-input>
                        </el-form-item>
                        <el-form-item label="任务名称：">
                            <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" v-model="form.workName"></el-input>
                        </el-form-item>
                        <el-form-item label="项目名称：">
                            <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" v-model="form.projectName"></el-input>
                        </el-form-item>
                        <el-form-item label="执法检查人员：">
                            <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" v-model="form.executorIdsName"></el-input>
                        </el-form-item>
                        <el-form-item label="数据所属部门：">
                        <select-depart-tree 
                        ref="selectDepartTreeRef"
                        :type="'2'"
                        :modelValue.sync="form.superviseDeptCodeList"  
                        :isMultiple="true" 
                        @handleDeptType="(val)=>changeDept(val,'5')" >
                        </select-depart-tree>
                        </el-form-item>
                </el-form>
                <div class="search-drawer__footer">
                    <el-button @click="searchBtn" size="small" type="primary">查询</el-button>
                    <el-button @click="refreshReset" plain size="small">重置</el-button>
                </div>
            </div>
        </searchBox>
        <div class="search-content">
            <div class="mainBtn">
                <el-button @click="routerAdd(1)" size="small" type="primary" v-if="hasBtnPermission('supervise_inspection_result_add')">新增检查结果录入</el-button>
                <el-button @click="viewStatistics" size="small">查看统计表</el-button>
            </div>
            <div class="searchBtn">
             
                <span class="label-form">抽取编号：</span>
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.extractCode"></el-input>
                <!-- <span class="label-form">项目名称：</span>
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.projectName"></el-input> -->
                <span class="label-form">任务名称：</span>
                <el-input @keyup.enter.native="searchBtn" clearable placeholder="请输入内容搜索" style="width: 200px" v-model="form.workName"></el-input>
                <el-button @click="searchBtn" size="small" style="margin-left: 12px" type="primary">搜索</el-button>
                <el-button @click="moreSearchItem = true" icon="el-icon-arrow-down" size="mini" type="text">更多搜索</el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button @click="refreshReset" icon="el-icon-refresh" type="text"></el-button>
            </div>
        </div>
        <template v-if="addStatisticsDialog">
            <inspectionResultStatistics ref="inspectionResultStatistics" @handleClose="handleClose"></inspectionResultStatistics>
        </template>
        <el-table :data="tableData"
                :header-cell-style="this.$globalGrayTableHeaderStyle"
                :height="tableMaxHeight"
                border class="table-content"
                ref="multipleTable" stripe v-loading="dataListLoading"
                @selection-change="handleSelectionChange">
            <el-table-column :show-overflow-tooltip='true' align="center" fixed  label="序号" type="index"
                             width="50"></el-table-column>
            <el-table-column align="center" fixed="right" label="操作" width="200">
              <template slot-scope="scope">
                <el-button @click="router(scope.row,1)" size="small" title="查看" type="text">查看</el-button>
                <el-button @click="router(scope.row,1)" size="small" title="录入抽查结果" type="text" v-if="hasBtnPermission('supervise_inspection_result_add') && scope.row.historyid==-2">录入执法检查结果</el-button>
                <el-button @click="router(scope.row,2)" size="small" title="变更" type="text" v-if="hasBtnPermission('supervise_inspection_result_change') && scope.row.historyid==0">变更</el-button>

                <!-- <el-button type="text" size="small" title="删除" v-if="hasBtnPermission('supervise_inspection_result_delete')" @click="deleteById(scope.row)">删除</el-button> -->
              </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="center" header-align="center" label="录入状态" min-width='90'
                             prop='businessName'>
                <template slot-scope="scope">
                    <i :class="formatterStatusClass(scope.row.historyid)"></i>
                    <span>{{formatterStatusName(scope.row.historyid)}}</span>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="left" label="项目名称" min-width='150'
                             prop='projectName'>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="left" label="项目编号" min-width='180'
                             prop='projectCode'>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="left"  label="执法人员" min-width='100'
                             prop='executorIdsName'>
                <template slot-scope="scope">
                    <span>{{scope.row.executorIdsName||'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="center" header-align="center" label="录入次数" min-width='100'
                             prop='enteringTimes'></el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="center" header-align="center" label="项目来源" min-width='100'
                             prop='sourceTypeName'>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="left"  label="抽取编号" min-width='100'
                             prop='extractCode'>
                   <template slot-scope="scope">
                    <span>{{scope.row.extractCode||'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="left"  label="任务名称" min-width='100'
                             prop='workName'>
                   <template slot-scope="scope">
                    <span>{{scope.row.workName||'--'}}</span>
                </template>
            </el-table-column>
            
            <el-table-column :show-overflow-tooltip='true' align="center" header-align="center" label="抽取时间" min-width='100'
                             prop='extractTime'>
                 <template slot-scope="scope">
                    <span>{{scope.row.extractTime||'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="center" header-align="center" label="录入时间" min-width='100'
                             prop='enteringTime'>
                <template slot-scope="scope">
                    <span>{{scope.row.enteringTime||'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column :show-overflow-tooltip='true' align="center" header-align="center" label="抽取类型" min-width='100'
                             prop='extractTypeName'>
                  <template slot-scope="scope">
                    <span>{{scope.row.extractTypeName||'--'}}</span>
                </template>
            </el-table-column>
        </el-table>
        <paginationCom  :options="paginationOpt" @pagechange="pageChangeHandle" @sizechange="sizeChangeHandle" class="limit"></paginationCom>
    </div>
  </div>
</template>

<script>
    import inspectionResultStatistics from './inspectionResultStatistics.vue'
    import {prjcheckresultbaseList} from '@/server/inspectionResult.js'
    // import {removeTabHandle} from '@/utils/routeTab';

    import selectDepartTree from "@/views/modules/components/selectDepartTree"
    import {mapState} from "vuex";
    export default {
    name: "busWitnessTable",
    data(){
      return {
        moreSearchItem:false,
        tableMaxHeight: document.documentElement.clientHeight - 237 ,
        dataListLoading: false,
        form: {
            extractCode:"",
            projectName:"",
            executorIdsName:"",
            workName:'',
            superviseDeptCodeList:[]
        },
        paginationOpt:{
          pageIndex:1,
          pageSize:10,
          total:0,
          pageSizes:[10,20,50]
        },
        tableData: [{type:1},{type:2}],
        multipleSelection: [],
        addStatisticsDialog:false,
        queryCode:''
      }
    },
    components:{
        inspectionResultStatistics,
        selectDepartTree

    },

    watch:{
      uerdefultOptionCode:{
        handler (val,oldVal){
          if(val.length!==0){  this.getData() }
        }
    }
    },
  computed: {
    ...mapState({
      uerdefultOptionCode: state => state.dataDictionary.uerdefultOptionCode,
            isAdmin: state => {return state.user.userinfo.selectRoleCode == "ADMIN"}
      
    }),
  },
    mounted() {
        const that = this;
        let resizeTag = true;
        this.queryCode=this.$route.query.code||''
        this.queryName=this.$route.query.name||''
        this.form.extractCode= this.queryCode
        this.form.workName=this.queryName
        this.getData();
        window.onresize = () => {
            if(resizeTag) { //防抖动
                that.ifmove();
                    resizeTag = false
                setTimeout(() => {
                    resizeTag = true
                }, 1000)
            }
        }
        that.ifmove();
    },
    methods:{
        changeDept(val,str){//切换部门
        this.form.superviseDeptCodeList=[]
        if(str==='5'){
            // 多选
            val.forEach((item,index)=>{
                if( item.type!=="region"){
                this.form.superviseDeptCodeList.push(item.code)
                }
            })
        }
    },
        formatterStatusClass(historyId){
            switch(historyId){
                case -2: return 'icon-point icon-point-verificationing'; break;
                case -1: return 'icon-point icon-point-verificationing'; break;
                default:return 'icon-point icon-point-success'; break;
            }
        },

        formatterStatusName(historyId){
            switch(historyId){
                case -2: return '待录入'; break;
                case -1: return '待备案'; break;
                default:return '已备案'; break;
            }
        },
        ifmove() {
             // let hasBtnPermisson = this.hasBtnPermission('');
             let tableMaxHeight = document.documentElement.clientHeight - 237 ;
             this.paginationOpt.pageSize = parseInt((tableMaxHeight) / 50 ) || 1;
             this.$nextTick(() => {
                 this.tableMaxHeight = tableMaxHeight
             })
        },
        getData() { // 获取列表数据
          this.dataListLoading=true;
           //数据所属部门
        this.form.superviseDeptCodeList= (this.form.superviseDeptCodeList || []).length==0?this.uerdefultOptionCode:this.form.superviseDeptCodeList
          prjcheckresultbaseList({
            'page': this.paginationOpt.pageIndex,
            'rows': this.paginationOpt.pageSize,
            'filter': {
                extractCode:this.form.extractCode,
                workName:this.form.workName,
                projectName:this.form.projectName,
                executorIdsName:this.form.executorIdsName,
                superviseDeptCodeList: this.form.superviseDeptCodeList
            }
          }).then(res => {
            this.tableData = res.data.rows;
            this.paginationOpt.total = res.data.total;
            this.$refs.multipleTable.doLayout();
            
          }).finally(()=>{this.dataListLoading = false;})
        },
        // 每页长度改变待办事项
        sizeChangeHandle(value){
          this.paginationOpt.pageSize=value;
          this.paginationOpt.pageIndex=1;
          this.getData();
        },
        // 当前页改变待办事项
        pageChangeHandle(value){
          this.paginationOpt.pageIndex = value;
          this.getData();
        },
        indexMethod(index) {
            return (this.paginationOpt.pageSize - 1) * Number(this.paginationOpt.pageSize) + Number(index) + 1
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        //搜索按钮
        searchBtn(){
            this.paginationOpt.pageIndex=1;
            this.moreSearchItem = false;
            this.getData()
        },
        dialogCancle(){
            this.moreSearchItem = false
        },
        refreshReset() {//重置按钮
            Object.assign(this.$data.form, this.$options.data().form)
            this.moreSearchItem = false;
            this.paginationOpt.pageIndex=1;
                // 重置默认所属数据
            if( this.$refs.selectDepartTreeRef){
                this.$refs.selectDepartTreeRef.getUserTreeOption()
            }
            this.getData();
        },
        routerAdd(type){//新增页面
          removeTabHandle('inspectionResult_detail') 
          this.$router.push({name:'inspectionResult_detail',query:{type:type}})
        },
        viewStatistics(){//查看统计表
            this.addStatisticsDialog=true;
            this.$nextTick(res=>{
                this.$refs.inspectionResultStatistics.dialogVisible=true;
            });
        },
        handleClose(){//关闭弹框
          this.addStatisticsDialog=false;
        },
        recoveryBtn(){//恢复
          if(this.multipleSelection.length==0){
            this.$message.warning('请选择项')
            return
          }
        },
        router(item,type){ // 跳转详情
            //sourceType=1 双随机 2定向
            removeTabHandle('inspectionResult_detail') 
            this.$router.push({
                name:'inspectionResult_detail',
                query:{
                  id:item.id,
                  type:type,
                  sourceType:item.sourceType
                }
            })
        },
    },

    destroyed(){
      window.onresize = null;
    },




}
</script>
<style lang="scss" scoped>

    //列表页面
    .main_center{
        .top{
            .searchBtn{
                margin-left:100px;
                display: flex;
            }
        }
    }

</style>
